import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Sidebar from "../components/Menu Section/Sidebar";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import ScrollTop from "../components/ScrollTop";

const OrderOnline = () => {
  const [data, setData] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const categoryRefs = useRef([]);
  const { restaurant, id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  console.log(restaurant, id);

  const getData = async () => {
    try {
      const res = await axios.get(
        `https://partnermeatwala.com/api/Vendor/GetVandoreDetails?id=${id}`
      );
      setData(res.data.restaurantmenulist);
      categoryRefs.current = res.data.restaurantmenulist.map(() =>
        React.createRef()
      );
      setActiveCategory(0); // Default to the first category
    } catch (error) {
      console.error("Error fetching restaurant info:", error.message || error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleCategoryClick = (index) => {
    setActiveCategory(index); // Set the active category
    if (categoryRefs.current[index] && categoryRefs.current[index].current) {
      categoryRefs.current[index].current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    categoryRefs.current.forEach((ref, index) => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
          setActiveCategory(index);
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
        className="breadcumb-wrapper"
        data-bg-src="assets/img/hero/hero_bg_3_2.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h2 className="breadcumb-title text-white">Menu</h2>
            <ul className="breadcumb-menu">
              <li>
                <Link
                  to={`https://halalmeats.store/${restaurant}/${id}`}
                  className="text-white"
                >
                  Home
                </Link>
              </li>
              <li>Menu</li>
            </ul>
          </div>
        </div>
      </div>
      <section className="mt-5">
        <div className="container">
          <div className="row">
            <div id="column-left">
              <div className="box">
                <div className="box-content" style={{ position: "relative" }}>
                  <button className="lefty paddle" id="left-button">
                    <i className="fa fa-angle-left" aria-hidden="true" />
                  </button>
                  <div className="box-category" id="scrollit">
                    <div className="cater" id="caterr">
                      <ul
                        id="left-side-bar-category"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {data?.map((item, index) => (
                          <li
                            className={`${
                              activeCategory === index ? "active-category" : ""
                            }`}
                            key={index}
                          >
                            <a
                              className="category-link"
                              style={{
                                fontSize: "17px",
                                textTransform: "uppercase",
                              }}
                              onClick={() => handleCategoryClick(index)}
                            >
                              {item.category}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <button className="righty paddle" id="right-button">
                    <i className="fa fa-angle-right" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-12 mb-5">
              {data?.map((category, index) => (
                <div
                  className="row mt-0 gy-40 menuu"
                  id={`cat_${index}`}
                  key={index}
                  ref={categoryRefs.current[index]}
                >
                  <div className="col-xl-12 col-lg-12 col-12 text-center">
                    <h4
                      style={{ fontWeight: "bold", textTransform: "uppercase" }}
                    >
                      {category.category}
                    </h4>
                  </div>
                  {category.items.map((item, idx) => (
                    <div className="col-xl-3 col-lg-3 col-6" key={idx}>
                      <div className="th-product product-grid">
                        <div className="product-img">
                          <img
                            src={`https://partnermeatwala.com/documents/${item.image}`}
                            alt={item.foodname}
                          />
                          {/* <span className="product-tag">Hot</span> */}
                        </div>
                        <div className="product-content">
                          <h3 className="product-title">{item.foodname}</h3>
                          <span className="price mb-2">£{item.cost}</span>
                          <a
                            href={`https://meatwala.co.uk/restaurant/${id}`}
                            target="_blank"
                            className="th-btn btn-sm style4"
                            style={{ color: "#fff" }}
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <ScrollTop />
    </>
  );
};

export default OrderOnline;
